// extracted by mini-css-extract-plugin
export default {"container":"SlideListView_container__juXqU"};